export default __webpack_public_path__ + "static/media/Cushion.dfdbd2ac.png";